import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import EmptyModal from "./freeModal";
import { SubSecMaster } from "../masters";
import { useNavigate } from "react-router-dom";
import { CallAPIPromise } from "../billing/common";

const SubSecMasterHelp = ({ onRowClick, status, onClose, section }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    // Change the shadow color
    overflow: "hidden",
    backgroundColor: "white",
  };
  const [filterText, setFilterText] = useState(section);
  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);
  const navigate = useNavigate();
  const prefix = useSelector(selectPrefix);
  const [masterStatus, setMasterStatus] = useState(false);

  const width = useSelector(selectWidth);
  const columns = [
    {
      field: "SUB_SEC_NAME",
      renderHeader: (params) => <div>Sub. Section Name</div>,
      width:
        width <= 768 ? 300 : width <= 1024 ? 300 : width <= 1440 ? 300 : 400,
      headerAlign: "center",
      align: "left",
    },
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [fullList, setFullList] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchQuery.substring(0, 1))) {
          return item.id.toString().includes(searchQuery);
        } else {
          return item.SUB_SEC_NAME.toLowerCase().includes(
            searchQuery.toLowerCase()
          );
        }
      });

      setRows(searchItems);
    } else {
      setRows(fullList);
    }
  }, [searchQuery]);

  const dispatch = useDispatch();
  useEffect(() => {
    setFilterText(section);
  }, [section]);
  const getData = async (ignoreSection) => {
    dispatch(setSpinnerLoading("Loading"));
    const data = {
      table_prefix: prefix,
      SUB_SEC_NAME: "",
      SECTION_NAME: ignoreSection ? "" : section ? section : "",
    };
    CallAPIPromise("/api/subMasterUtils/listSubSectionMaster", data, token)
      .then((p) => {
        if (!p.data.error) {
          let list = [];
          const data = p.data.response;

          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            onClose();
            setSearchQuery("");

            setRows([]);
          }}
          filterTag={filterText}
          onFilterClear={() => {
            getData(true);
            setFilterText("");
          }}
          title={"Sub Section Master | Help"}
          columns={columns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          CreateNew={() => {
            setMasterStatus(true);
          }}
          goToMaster={() => {
            navigate("/sub_section_master");
          }}
          onRowClick={(p) => {
            onRowClick(p);
            setRows([]);
          }}
        />
        <EmptyModal
          status={masterStatus}
          onClose={() => {
            setMasterStatus(false);
          }}
          Component={SubSecMaster}
          afterCreate={() => {
            setMasterStatus(false);
            getData();
          }}
        />
      </div>
    </>
  );
};

export default SubSecMasterHelp;
